module.exports = __webpack_public_path__ + "img/bgbg.f665e9bf.png";